export default "/_next/static/676248ed9735b7707f550f0b667eb380.png";